import { request } from './client';

export type ServingStatus = 'serving' | 'not_serving' | 'unspecified';

export interface DependencyStatus {
  name: string;
  status: ServingStatus;
  detail?: string;
}

export interface HealthResponse {
  status: ServingStatus;
  version: string;
  services: DependencyStatus[];
}

/**
 * Reads the aggregate health of the backend.
 *
 * Returns a 503 with a body rather than an empty error, so the failing service
 * is named even when the system is down.
 */
export function getHealth(signal?: AbortSignal): Promise<HealthResponse> {
  return request<HealthResponse>('/health', signal ? { signal } : {});
}

export interface CsrfResponse {
  token: string;
}

/** Requests a CSRF token and the matching cookie. */
export function getCsrfToken(signal?: AbortSignal): Promise<CsrfResponse> {
  return request<CsrfResponse>('/csrf', signal ? { signal } : {});
}
